import { r as createLogger } from "../logger-BU8YqMGU.js";
//#region ../src/ar/xr-camera-texture.ts
const log = createLogger("XRCameraTexture");
/**
* Acquire the camera texture for the current XR frame using Three.js's
* built-in getCameraTexture() API, paired with native camera dimensions.
*
* Three.js internally:
* 1. Creates XRWebGLBinding (lazy, one per session)
* 2. Calls glBinding.getCameraImage(camera) each frame
* 3. Wraps in ExternalTexture (sourceTexture = native WebGLTexture)
* 4. Caches per xrCamera in cameraAccessTextures map
*
* This function adds the native camera dimensions (width/height) needed
* for dynamic render target sizing in the blit capture pipeline.
*
* Must be called within the XR animation frame callback.
*
* @param renderer - The Three.js WebGLRenderer
* @param xrCamera - The XRCamera from XRView.camera, or null if unavailable
* @returns CameraTextureResult, or null if acquisition fails
*/
function acquireCameraTexture(renderer, xrCamera) {
	if (!xrCamera) return null;
	try {
		const texture = renderer.xr.getCameraTexture(xrCamera);
		if (!texture) return null;
		return {
			texture,
			width: xrCamera.width,
			height: xrCamera.height
		};
	} catch (error) {
		log.error("Failed to acquire camera texture:", error);
		return null;
	}
}
//#endregion
export { acquireCameraTexture };
